import React, { createContext, useContext, useState, useEffect } from "react";

import PropTypes from "prop-types";

const LeftBarContext = createContext();

export function LeftBarProvider({ children }) {
  const [leftBarOpened, setLeftBarOpened] = useState(() => {
    const saved = localStorage.getItem("leftBarOpened");
    return saved !== null ? JSON.parse(saved) : true;
  });

  useEffect(() => {
    localStorage.setItem("leftBarOpened", JSON.stringify(leftBarOpened));
  }, [leftBarOpened]);

  return (
    <LeftBarContext.Provider value={{ leftBarOpened, setLeftBarOpened }}>
      {children}
    </LeftBarContext.Provider>
  );
}

export function useLeftBar() {
  const context = useContext(LeftBarContext);

  if (!context) {
    throw new Error("useLeftBar must be used within a LeftBarProvider");
  }

  return context;
}

LeftBarProvider.defaultProps = {
  children: {},
};

LeftBarProvider.propTypes = {
  children: PropTypes.object,
};
